module.exports = __webpack_public_path__ + "img/bg-flujo-compra.e41d169c.png";